var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home h-100"},[_c('Navbar'),_c('section',{staticClass:"mt-3",staticStyle:{"min-height":"50vh"}},[_c('BlockListViewer',{attrs:{"blocks":_vm.blocks}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }